import { Text } from "@flare/ui/components";
import { cn } from "@flare/ui/utils";

export function StepSubtitle({
  children,
  className,
  ...restProps
}: React.ComponentProps<typeof Text>) {
  return (
    <Text
      className={cn(
        "mx-auto my-sp-3 max-w-[520px] text-balance text-center",
        className,
      )}
      {...restProps}
    >
      {children}
    </Text>
  );
}
